"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MerchandizingItem = void 0;
var _mui = require("@ori-ui/mui");
var _checkoutUi = require("@ori/checkout-ui");
var _ProgressBar = require("./ProgressBar");
var _jsxRuntime = require("react/jsx-runtime");
const ContentWrapper = (0, _mui.styled)('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1
}));
const Header = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  [theme.breakpoints.up(920)]: {
    marginBottom: theme.spacing(1)
  }
}));
const Content = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  display: 'inline-block',
  position: 'relative',
  [theme.breakpoints.up(920)]: {
    fontSize: theme.typography.body1.fontSize,
    paddingRight: theme.spacing(6)
  }
}));
const MerchandizingItem = ({
  'data-testid': testId,
  progress,
  text,
  title
}) => {
  const theme = (0, _mui.useTheme)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_checkoutUi.InfoBanner, {
    "data-testid": testId,
    iconName: "GiftFilled",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(ContentWrapper, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(Header, {
        fontWeight: "bold",
        variant: "body1",
        children: title
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(Content, {
        variant: "caption",
        children: text
      }), progress ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_ProgressBar.ProgressBar, {
        progress: progress,
        color: theme.palette.success.main
      }) : null]
    })
  });
};
exports.MerchandizingItem = MerchandizingItem;